import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

export default function UnsubscribeSubscription() {
    const { token } = useParams();

    const [status, setStatus] = useState("loading");
    const [message, setMessage] = useState("");

    useEffect(() => {
        if (!token) {
            setStatus("error");
            setMessage("Invalid unsubscribe link.");
            return;
        }

        // optional: verify token first (we will improve later)
        setStatus("ready");
    }, [token]);

    const handleUnsubscribe = () => {
        setStatus("loading");

        axios
            .post("https://beachhoteldubai.com/api/subscribe/unsubscribe", {
                token: token,
            })
            .then((res) => {
                setStatus("unsubscribed");
                setMessage(res.data.message);
            })
            .catch((err) => {
                setStatus("error");
                setMessage(
                    err.response?.data?.message || "Something went wrong."
                );
            });
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
            <div className="bg-white rounded-2xl shadow-md border p-8 max-w-md w-full text-center">

                {/* Loading */}
                {status === "loading" && (
                    <p className="text-gray-500">Processing...</p>
                )}

                {/* Ready */}
                {status === "ready" && (
                    <div>
                        <div className="text-5xl mb-3">📧</div>

                        <h2 className="text-gray-800 font-bold text-lg">
                            Confirm Unsubscribe
                        </h2>

                        <p className="text-gray-500 mt-2">
                            Are you sure you want to unsubscribe from our newsletter?
                        </p>

                        <button
                            onClick={handleUnsubscribe}
                            className="mt-5 bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg text-sm"
                        >
                            Yes, Unsubscribe
                        </button>
                    </div>
                )}

                {/* Success */}
                {status === "unsubscribed" && (
                    <div>
                        <div className="text-5xl mb-3">👋</div>

                        <h2 className="text-green-600 font-bold text-lg">
                            Unsubscribed Successfully
                        </h2>

                        <p className="text-gray-500 mt-2">
                            {message}
                        </p>
                    </div>
                )}

                {/* Error */}
                {status === "error" && (
                    <p className="text-red-500">
                        {message}
                    </p>
                )}

            </div>
        </div>
    );
}